import { Root } from './styles';
import type { DialogProps } from './types';

export const Dialog = ({ children, container, header, id, onClose, open, zIndex }: DialogProps) => (
  <Root
    container={container}
    header={header}
    id={id}
    open={open ?? false}
    size="small"
    zIndex={zIndex}
    onClose={onClose}
  >
    {children}
  </Root>
);
